import React, { useRef } from 'react';
import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import { Carousel } from 'components/Carousel';
import afterArrow from 'assets/afterArrow.svg';
import { colors, Figure, Div } from 'globalStyle';
import previewArrow from 'assets/previewArrow.svg';

const settings = {
  autoplay: false,
  infinite: false,
  adaptiveHeight: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

export const Assets = ({
  height = 'calc(95dvh - 80px)',
  width = '100%',
  children,
  video: Video = null,
  photoProduct = [],
}) => {
  const carousel = useRef(null);
  const next = () => carousel.current.slickNext();
  const prev = () => carousel.current.slickPrev();

  return (
    <div>
      <Box height={height} width={width} position="relative" maxHeight="calc(95dvh - 80px)">
        <Actions>
          <Carousel refCarousel={carousel} {...settings}>
            {Video && <Video height={height} />}
            {photoProduct.map((photo) => (
              <Figure height={height} width={width}>
                <img
                  src={photo}
                  alt="package"
                  style={{
                    objectFit: 'cover',
                  }}
                />
              </Figure>
            ))}
          </Carousel>
          <Div
            onClick={prev}
            style={{
              zIndex: 2,
              left: '30px',
              width: '40px',
              bottom: '50%',
              opacity: '0.4',
              height: '40px',
              cursor: 'pointer',
              borderRadius: '50%',
              position: 'absolute',
              background: colors.BLACK,
              backdropfilter: 'blur(5px)',
            }}
          />
          <Figure
            z={2}
            width="8px"
            height="15px"
            onClick={prev}
            style={{
              left: '45px',
              cursor: 'pointer',
              position: 'absolute',
              bottom: 'calc(50% + 12px)',
            }}
          >
            <img src={previewArrow} alt="imagen anterior" />
          </Figure>
          <Div
            onClick={next}
            style={{
              zIndex: 2,
              width: '40px',
              right: '30px',
              bottom: '50%',
              height: '40px',
              opacity: '0.4',
              cursor: 'pointer',
              borderRadius: '50%',
              position: 'absolute',
              background: colors.BLACK,
              backdropfilter: 'blur(5px)',
            }}
          />
          <Figure
            z={2}
            width="8px"
            right="15px"
            onClick={next}
            style={{
              right: '45px',
              cursor: 'pointer',
              position: 'absolute',
              bottom: 'calc(50% + 12px)',
            }}
          >
            <img src={afterArrow} alt="siguiente imagen" />
          </Figure>
        </Actions>
      </Box>
      {children}
    </div>
  );
};

const Actions = styled.div`

  .right, .left{
    position: absolute;
    margin: 0;
    padding: 10px 0;
    font-size: 50px;
    color: white;
    border-radius: 100%;
    background-color: rgba(242, 243, 241, 0.3);
    cursor: pointer;
  }
  .right{
    right: 30px;
    top: calc(50% - 25px);
  }
  .left{
    left: 20px;
    top: calc(50% - 25px);
  }

  .slick-dots{
    bottom: 10px;
    z-index: 2;

    left: 50%;
    margin-left: -50px;
    width: auto;
    padding: 0;

    & button:before {
      color: ${colors.WHITE};
      font-size: 12px;
      opacity: 1;

    }

    & li.slick-active button:before{
      color: ${colors.primary};
      opacity: 1;
    }

  }
`;
